import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const ACTION_HELP = {
  lead: { title: "Add Lead", short: "Create or link a Person and begin recruiting them.",
    long: "Use this when you want to recruit someone for an opportunity. Top-Recruit will create or reuse their Person record and add them to the recruiting workflow. This does not automatically give them a login." },
  person: { title: "Add Person", short: "Add someone to the master People database without automatically creating recruiting access.",
    long: "Use this when you need someone in the People database but are not necessarily recruiting them. Adding a Person does not automatically create a recruiting record or login." },
  invite: { title: "Invite User", short: "Give an existing or new Person permission to sign in.",
    long: "Use this when someone needs permission to sign in to Top-Recruit. Existing People and accounts are reused whenever possible." },
};

export function HelpHint({ kind, testId }) {
  const h = ACTION_HELP[kind];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" aria-label={`About ${h.title}`} className="inline-flex h-6 w-6 items-center justify-center rounded-full text-slate-400 hover:text-[#006090] hover:bg-slate-100 transition-colors" data-testid={testId}>
          <Info className="w-4 h-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs bg-slate-900 text-white leading-relaxed" data-testid={`${testId}-content`}>
        <p className="font-semibold mb-0.5">{h.title}</p><p>{h.long}</p>
      </TooltipContent>
    </Tooltip>
  );
}
